import { Box, Divider, Flex, Heading, Tabs, TabList, TabPanels, Tab, TabPanel, VStack, StackDivider, Image, Text, Button, useMediaQuery } from '@chakra-ui/react';
import React, { useState } from 'react';
import { responsiveValue } from '../../../assets/style/defaultTheme';
import { ActivityTable } from './style';
import MorePanel from '../../../Component/MorePanel';
import { slashToBr } from '../../../util';
import { theme } from '../../../assets/style/theme';

const { flexBoxDirection, participationSideBoxWidth, participationContentBoxWidth } = responsiveValue;

type Props = {
  data:any;
};

const limitationList = (list:[], limit: number) => {		
  return list.slice(0, limit);
}

const isEnglish = window.__LANG__ === 'en';

function ParticipationContentItemActivityRepeat({ data }: Props) {
  const [tabIndex, setTabIndex] = useState(0);
  const [listOpen, setListOpen] = useState(false);

  const [isMobile] = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

  return (
    <Tabs orientation={isMobile ? 'horizontal' : 'vertical'} variant='unstyled' colorScheme='dgr' onChange={(index) => setTabIndex(index)}>
      <TabList pt="5" pr="5" w={participationSideBoxWidth} >
        {
          data.map((item: any, index: number) => (
            <Tab mb={2} pl="0" textAlign="left" display="block" >
              <Heading size={isMobile ? '2xl' : '4xl'} color={index === tabIndex ? 'b.dgr' : 'b.lg'} >{item.title}</Heading>              
            </Tab>
          ))
        }
      </TabList>

      <TabPanels w={participationContentBoxWidth} p={0}>
        
        {
          data.map((item: any) => (
            <TabPanel p={0}>
              <VStack
                divider={<StackDivider borderColor='b.lg' />}
                spacing={3}
                align='stretch'
              >
              {
                limitationList(item?.meta?.activity_re_, !listOpen ? 5 : 1000)?.map((subItem:any, index:number) => (
                  <div key={index}>
                    <Flex>
                      <Image src={subItem.activity_list_image.url} fallbackSrc="https://dummyimage.com/180x148/cccccc/fff" w={isMobile ? '120px' : '180px'} objectFit="cover" borderRadius="10" />
                      <Box pl="4">
                        <Heading size="xl" pb="3" color="b.g" dangerouslySetInnerHTML={{__html: slashToBr(subItem.activity_list_title)}}></Heading>
                        {
                          subItem.activity_list_sns && (
                            <Heading size="lg" pb="3" color="b.gr" wordBreak="break-all">{subItem.activity_list_sns}</Heading>
                          )
                        }
                        <Text fontSize="md" dangerouslySetInnerHTML={ {__html: subItem.activity_list_text.replaceAll('-', '<br/>-')} } />
                      </Box>
                    </Flex>
                  </div>
                ))
              }
              </VStack>
              <Box textAlign="center" pt="6">
              <Button fontSize="2xl" color="b.lg" colorScheme="wh" onClick={() => setListOpen(!listOpen)}>
                {
                  listOpen ? isEnglish ? 'Close' : '닫기' : isEnglish ? 'View All' : '전체보기'
                }
              </Button>
              </Box>
            </TabPanel>
          ))
        }
      </TabPanels>
    </Tabs>
  );
}

ParticipationContentItemActivityRepeat.defaultProps = {
};

export default ParticipationContentItemActivityRepeat;
